import {
  formatPercentageValue,
  createKpiTileItem,
  formatNormalNumber,
} from '../../../utils/helper';
import { constants } from '../../../../constants/Constants';

function getTitle(selectedProduct) {
  return selectedProduct?.productId === constants.products.MCT
    ? constants.overview.uniqueUsers
    : constants.overview.uniqueSessions;
}

export default {
  type: 'KpiTile',
  handler: (data, selectedProduct) => {
    const { uniqueSessions, uniqueSessionsDelta } =
      data?.getUserAdoptionScorecard?.data || {};

    return createKpiTileItem(
      getTitle(selectedProduct),
      formatNormalNumber(uniqueSessions),
      uniqueSessionsDelta
        ? {
            isPositiveValue: uniqueSessionsDelta >= 0,
            text: formatPercentageValue(Math.abs(uniqueSessionsDelta)),
            sideLabel: '',
            showArrow: Number(uniqueSessionsDelta) !== 0,
          }
        : null
    );
  },
};
